export class ComponenteKitPedido {
  id: number;
  item: any;
  adicionalId: number;
  qtdeUnidades: number;
  quantidadeFechadaId: number = null;
  nome: string;
  descricaoQuantidade: string;
  valor: number;
}
